var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMusicFestival = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5 15.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M.25 19a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.25 2.384a.25.25 0 0 0-.328-.237l-10 3.308a.25.25 0 0 0-.172.237V19a.75.75 0 0 1-1.5 0V5.692a1.75 1.75 0 0 1 1.2-1.661l10-3.308a1.75 1.75 0 0 1 2.3 1.661v13.657a.75.75 0 0 1-1.5 0z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17 12.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M12.25 16a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
  clipRule: "evenodd"
})));
export default SvgMusicFestival;